import type {ComponentType} from 'react';
import {Navigate, useLocation} from 'react-router';
import {LoadingScreen} from 'src/components/LoadingScreen';
import {useAuth} from 'src/auth/context';
import {loginRoute} from 'src/routes';

/**
 * Renders `component` only for a signed-in person, and sends everyone else to
 * the sign-in page with the address they were trying to reach.
 */
export const PrivateRoute = ({component: Component}: {component: ComponentType}) => {
  const {isLoading, isAuthenticated} = useAuth();
  const location = useLocation();

  if (isLoading) return <LoadingScreen isFullScreen />;

  if (!isAuthenticated) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={loginRoute} replace state={{returnTo}} />;
  }

  return <Component />;
};
